"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageFamilyEditedEvent = exports.PackageAutopublishSkippedEvent = exports.PackageAutopublishedEvent = exports.PackagePublishedEvent = exports.PackageEditedEvent = exports.PackageCreatedEvent = void 0;
const zod_1 = require("zod");
const event_1 = require("../event");
const build_ancestry_1 = require("../build-ancestry");
const package_milestone_enums_1 = require("./package-milestone-enums");
exports.PackageCreatedEvent = (0, event_1.createEventClass)('PackageCreatedEvent', zod_1.z.object({
    ...build_ancestry_1.buildAncestryShape,
    packageId: zod_1.z.string(),
    manufacturerPartNumber: zod_1.z.string(),
    packageFamilyId: zod_1.z.string().nullable(),
    initialSigmaModelType: zod_1.z.string(),
    initialPinCountEstimate: zod_1.z.number().int().nullable(),
    hasDatasheetFileAtCreation: zod_1.z.boolean(),
    origin: zod_1.z.nativeEnum(package_milestone_enums_1.PackageCreationOrigin),
}));
exports.PackageEditedEvent = (0, event_1.createEventClass)('PackageEditedEvent', zod_1.z.object({ packageId: zod_1.z.string() }));
exports.PackagePublishedEvent = (0, event_1.createEventClass)('PackagePublishedEvent', zod_1.z.object({
    ...build_ancestry_1.buildAncestryShape,
    packageId: zod_1.z.string(),
    autopublished: zod_1.z.boolean().optional(),
    sigmaModelType: zod_1.z.string(),
    pinCount: zod_1.z.number().int().nullable().optional(),
    manufacturerPartNumber: zod_1.z.string().optional(),
}));
exports.PackageAutopublishedEvent = (0, event_1.createEventClass)('PackageAutopublishedEvent', zod_1.z.object({
    ...build_ancestry_1.buildAncestryShape,
    packageId: zod_1.z.string(),
    sigmaModelType: zod_1.z.string(),
    manufacturerPartNumber: zod_1.z.string(),
    pinCount: zod_1.z.number().int(),
}));
exports.PackageAutopublishSkippedEvent = (0, event_1.createEventClass)('PackageAutopublishSkippedEvent', zod_1.z.object({
    ...build_ancestry_1.buildAncestryShape,
    packageId: zod_1.z.string(),
    sigmaModelType: zod_1.z.string(),
    manufacturerPartNumber: zod_1.z.string(),
    reason: zod_1.z.string(),
    failedHeuristics: zod_1.z.array(zod_1.z.string()),
    pinCount: zod_1.z.number().int().nullable(),
}));
exports.PackageFamilyEditedEvent = (0, event_1.createEventClass)('PackageFamilyEditedEvent', zod_1.z.object({ packageFamilyId: zod_1.z.string() }));
//# sourceMappingURL=package-events.js.map